// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_JBK","icon":"styles_icon__2ouOE"};